import { UserRound } from "lucide-react";

export const ActivityLog = ({ logs }) => (
  <div className="p-6 border border-[#262626] bg-[#141414] flex flex-col gap-4" data-testid="activity-log">
    <h3 className="text-xl font-semibold">Recent Activity</h3>
    {logs.length === 0 && <p className="text-sm text-[#A3A3A3]">No activity yet.</p>}
    <div className="flex flex-col divide-y divide-[#262626]">
      {logs.map((l) => (
        <div key={l.id} data-testid={`log-${l.id}`} className="py-3 flex justify-between gap-3 text-sm">
          <span className="min-w-0">
            <span className="block text-[#F5F5F5] truncate">
              <span className="label-tech mr-2">{String(l.number).padStart(2, "0")}</span>
              {l.action} {l.plate ? `· ${l.plate}` : ""} {l.driver ? `· ${l.driver}` : ""}
            </span>
            {l.by && (
              <span
                className="flex items-center gap-1 text-[11px] text-[#A3A3A3] mt-1"
                data-testid={`log-by-${l.id}`}
              >
                <UserRound className="w-3 h-3 shrink-0" />
                {l.by}
              </span>
            )}
          </span>
          <span className="text-[#A3A3A3] whitespace-nowrap">
            {new Date(l.at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
          </span>
        </div>
      ))}
    </div>
  </div>
);
